/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlternativeCredentials } from '../../models/alternative-credentials';

export interface ApiAccountAlternativeCredentialsGet$Params {
  'api-version'?: string;
}

export function apiAccountAlternativeCredentialsGet(http: HttpClient, rootUrl: string, params?: ApiAccountAlternativeCredentialsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AlternativeCredentials>> {
  const rb = new RequestBuilder(rootUrl, apiAccountAlternativeCredentialsGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlternativeCredentials>;
    })
  );
}

apiAccountAlternativeCredentialsGet.PATH = '/api/account/alternative-credentials';
